import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { creditCardBillingAddressEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

creditCardBillingAddressEntryStyles.container = mergeToNew(creditCardBillingAddressEntryStyles.container, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 18px 0 0;
                    `,
                    css`
                        padding: 18px 0 0;
                    `,
                    css`
                        padding: 18px 0 0;
                    `,
                    css`
                        padding: 15px;
                    `,
                    css`
                        padding: 15px;
                    `,
                ],
                "min",
            )}
    `,
});

creditCardBillingAddressEntryStyles.headingGridItem = mergeToNew(creditCardBillingAddressEntryStyles.headingGridItem, {
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
    `,
});

creditCardBillingAddressEntryStyles.heading = mergeToNew(creditCardBillingAddressEntryStyles.heading, {
    css: css`
        margin-bottom: 3px;
    `,
});

creditCardBillingAddressEntryStyles.useBillingAddressGridItem = mergeToNew(
    creditCardBillingAddressEntryStyles.useBillingAddressGridItem,
    {
        css: css`
            padding-top: 22px;
        `,
    },
);
